import { render, staticRenderFns } from "./SchoolCalendar.vue?vue&type=template&id=35104c57"
import script from "./SchoolCalendar.vue?vue&type=script&lang=js"
export * from "./SchoolCalendar.vue?vue&type=script&lang=js"
import style0 from "./SchoolCalendar.vue?vue&type=style&index=0&id=35104c57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports